import axios from 'axios';

// Gracias al proxy de Nginx, podemos usar rutas relativas y él se encargará
// de redirigir las peticiones de /api/v1/* al backend de FastAPI.
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
});

export const getConfigurations = async () => {
  try {
    const response = await apiClient.get('/api/v1/configurations');
    return response.data;
  } catch (error) {
    console.error("Error fetching configurations:", error);
    throw error;
  }
};

export const getEventTypes = async () => {
    try {
        const response = await apiClient.get('/api/v1/event-types');
        return response.data;
    } catch (error) {
        console.error("Error fetching event types:", error);
        throw error;
    }
};
